'use strict'
import $ from 'jquery';
import FHConvert from '@/common/converter/fhconvert.js';
import ValidationUtils from '@/common/utils/ValidationUtils.js';
import IConstants from "@/common/constants/IConstants";
import ModalPlugin from "@/common/plugins/ModalPlugin";
import i18n from "@/lang/i18n";
import {detect} from "detect-browser";
import {compare} from 'compare-versions';
import EventBus from "@/services/EventBus";
import store from '@/store/index';

var self = new Object();

		self.hirakanaMap = new Array();
		self.hirakanaMap.push(new Array("ア", "ｱ"));
		self.hirakanaMap.push(new Array("カ", "ｶ"));
		self.hirakanaMap.push(new Array("ガ", "ｶﾞ"));
		self.hirakanaMap.push(new Array("サ", "ｻ"));
		self.hirakanaMap.push(new Array("ザ", "ｻﾞ"));
		self.hirakanaMap.push(new Array("タ", "ﾀ"));
		self.hirakanaMap.push(new Array("ダ", "ﾀﾞ"));
		self.hirakanaMap.push(new Array("ナ", "ﾅ"));
		self.hirakanaMap.push(new Array("ハ", "ﾊ"));
		self.hirakanaMap.push(new Array("バ", "ﾊﾞ"));
		self.hirakanaMap.push(new Array("パ", "ﾊﾟ"));
		self.hirakanaMap.push(new Array("マ", "ﾏ"));
		self.hirakanaMap.push(new Array("ヤ", "ﾔ"));
		self.hirakanaMap.push(new Array("ラ", "ﾗ"));
		self.hirakanaMap.push(new Array("ワ", "ﾜ"));
		self.hirakanaMap.push(new Array("ン", "ﾝ"));
		self.hirakanaMap.push(new Array("イ", "ｲ"));
		self.hirakanaMap.push(new Array("キ", "ｷ"));
		self.hirakanaMap.push(new Array("ギ", "ｷﾞ"));
		self.hirakanaMap.push(new Array("シ", "ｼ"));
		self.hirakanaMap.push(new Array("ジ", "ｼﾞ"));
		self.hirakanaMap.push(new Array("チ", "ﾁ"));
		self.hirakanaMap.push(new Array("ヂ", "ﾁﾞ"));
		self.hirakanaMap.push(new Array("ニ", "ﾆ"));
		self.hirakanaMap.push(new Array("ヒ", "ﾋ"));
		self.hirakanaMap.push(new Array("ビ", "ﾋﾞ"));
		self.hirakanaMap.push(new Array("ピ", "ﾋﾟ"));
		self.hirakanaMap.push(new Array("ミ", "ﾐ"));
		self.hirakanaMap.push(new Array("イ", "ｲ"));
		self.hirakanaMap.push(new Array("リ", "ﾘ"));
		self.hirakanaMap.push(new Array("イ", "ｲ"));
		self.hirakanaMap.push(new Array("ウ", "ｳ"));
		self.hirakanaMap.push(new Array("ク", "ｸ"));
		self.hirakanaMap.push(new Array("グ", "ｸﾞ"));
		self.hirakanaMap.push(new Array("ス", "ｽ"));
		self.hirakanaMap.push(new Array("ズ", "ｽﾞ"));
		self.hirakanaMap.push(new Array("ツ", "ﾂ"));
		self.hirakanaMap.push(new Array("ヅ", "ﾂﾞ"));
		self.hirakanaMap.push(new Array("ヌ", "ﾇ"));
		self.hirakanaMap.push(new Array("フ", "ﾌ"));
		self.hirakanaMap.push(new Array("ブ", "ﾌﾞ"));
		self.hirakanaMap.push(new Array("プ", "ﾌﾟ"));
		self.hirakanaMap.push(new Array("ム", "ﾑ"));
		self.hirakanaMap.push(new Array("ユ", "ﾕ"));
		self.hirakanaMap.push(new Array("ル", "ﾙ"));
		self.hirakanaMap.push(new Array("エ", "ｴ"));
		self.hirakanaMap.push(new Array("ケ", "ｹ"));
		self.hirakanaMap.push(new Array("ゲ", "ｹﾞ"));
		self.hirakanaMap.push(new Array("セ", "ｾ"));
		self.hirakanaMap.push(new Array("ゼ", "ｾﾞ"));
		self.hirakanaMap.push(new Array("テ", "ﾃ"));
		self.hirakanaMap.push(new Array("デ", "ﾃﾞ"));
		self.hirakanaMap.push(new Array("ネ", "ﾈ"));
		self.hirakanaMap.push(new Array("ヘ", "ﾍ"));
		self.hirakanaMap.push(new Array("ベ", "ﾍﾞ"));
		self.hirakanaMap.push(new Array("ペ", "ﾍﾟ"));
		self.hirakanaMap.push(new Array("メ", "ﾒ"));
		self.hirakanaMap.push(new Array("エ", "ｴ"));
		self.hirakanaMap.push(new Array("レ", "ﾚ"));
		self.hirakanaMap.push(new Array("エ", "ｴ"));
		self.hirakanaMap.push(new Array("オ", "ｵ"));
		self.hirakanaMap.push(new Array("コ", "ｺ"));
		self.hirakanaMap.push(new Array("ゴ", "ｺﾞ"));
		self.hirakanaMap.push(new Array("ソ", "ｿ"));
		self.hirakanaMap.push(new Array("ゾ", "ｿﾞ"));
		self.hirakanaMap.push(new Array("ト", "ﾄ"));
		self.hirakanaMap.push(new Array("ド", "ﾄﾞ"));
		self.hirakanaMap.push(new Array("ノ", "ﾉ"));
		self.hirakanaMap.push(new Array("ホ", "ﾎ"));
		self.hirakanaMap.push(new Array("ボ", "ﾎﾞ"));
		self.hirakanaMap.push(new Array("ポ", "ﾎﾟ"));
		self.hirakanaMap.push(new Array("モ", "ﾓ"));
		self.hirakanaMap.push(new Array("ヨ", "ﾖ"));
		self.hirakanaMap.push(new Array("ロ", "ﾛ"));
		self.hirakanaMap.push(new Array("ヲ", "ｦ"));
		self.hirakanaMap.push(new Array("ャ", "ｬ"));
		self.hirakanaMap.push(new Array("ュ", "ｭ"));
		self.hirakanaMap.push(new Array("ョ", "ｮ"));
		self.hirakanaMap.push(new Array("ッ", "ｯ"));
		self.hirakanaMap.push(new Array("ー", "ｰ"));
		self.hirakanaMap.push(new Array("ヴ", "ｳﾞ"));
		self.hirakanaMap.push(new Array("ヮ", "ﾜ"));
		self.hirakanaMap.push(new Array("ヵ", "ｶ"));
		self.hirakanaMap.push(new Array("ヶ", "ｹ"));
		self.hirakanaMap.push(new Array("ヰ", "ｳｨ"));
		self.hirakanaMap.push(new Array("ァ", "ｧ"));
		self.hirakanaMap.push(new Array("ィ", "ｨ"));
		self.hirakanaMap.push(new Array("ゥ", "ｩ"));
		self.hirakanaMap.push(new Array("ェ", "ｪ"));
		self.hirakanaMap.push(new Array("ォ", "ｫ"));

		self.getUpperCaseKana = function(kanaVal){
			var smallKana = Array('ァ','ィ','ゥ','ェ','ォ','ヵ','ヶ','ㇱ','ㇲ','ッ','ㇳ','ㇴ','ㇵ','ㇶ','ㇷ','ㇸ','ㇹ','ㇺ','ャ','ュ','ョ','ㇻ','ㇼ','ㇽ','ㇾ','ㇿ','ヮ');
			var bigKana   = Array('ア','イ','ウ','エ','オ','カ','ケ','シ','ス','ツ','ト','ヌ','ハ','ヒ','フ','ヘ','ホ','ム','ヤ','ユ','ヨ','ラ','リ','ル','レ','ロ','ワ');
			var ckanaVal = '';
			for (var i = 0; i < kanaVal.length; i++){
				//var index = smallKana.indexOf(kanaVal.charAt(i)); //indexOf and stri[i] don't work on ie
				var index = $.inArray(kanaVal.charAt(i), smallKana);
				if (index !== -1) {
					ckanaVal+= bigKana[index];
				}
				else
				{
					ckanaVal+= kanaVal.charAt(i);
				}
			}
			return ckanaVal;
		}

		self.halfFullConvert = function(str, flag){
			var i;
			var result='';
			if (str == null || str.length<=0) {
				return result;
			}
			str = str.trim();
			for(i=0;i<str.length;i++) {
				var str1=str.charCodeAt(i);
				if (str1==32&&!flag) {
					result+='　';
				} else if (str1<125&&!flag) {
					result+=String.fromCharCode(str1+65248);
				} else if (str1>65248&&flag) {
					result+=String.fromCharCode(str1-65248);
				} else {
					result+=String.fromCharCode(str1);
				}
			}
			return result;
		}

		self.replaceInvalidBjpCharacters = function(a){
			var accepted = String.fromCharCode(8208);
			var invalids = [8209, 8210, 8211, 8212, 8213, 8315, 8331, 8722];
			for(var i = 0; i < invalids.length; i++){
				a = a.replace(new RegExp(String.fromCharCode(invalids[i]), 'g'), accepted);
			}
			return a;
		}

		self.convertHalfwidthToFullwidthReturn = function(input){
			if(input != null || typeof input != "undefined"){
				input = input.trim();
				input=self.convertToHiraKana(input);
				input=self.convertToEmhyphen(input);
				var f2=FHConvert.htof(input, {'space': true});
				//f2 = removeSpace(f2);
				return f2
			}else {
				return "";
			}
		}

		self.convertHalfToFull = function(input){
			if(input != null || typeof input != "undefined"){
				input = input.trim();
				input=self.convertToHiraKana(input);
				var f2=FHConvert.htof(input, {'space': true});
				//f2 = removeSpace(f2);
				return f2
			}else {
				return "";
			}
		}

		self.convertFullwidthToHalfwidthReturn = function(input){
			if(input != null || typeof input != "undefined"){
				var f2=FHConvert.ftoh(input);
				//f2 = removeSpace(f2);
				return f2
			}else {
				return "";
			}
		}

		self.convert = function(c) {
			for (var i = 0; i < self.hirakanaMap.length; i++) {
				if (self.hirakanaMap[i][1] == c) {
					return self.hirakanaMap[i][0];
				}
			}
			return c;
		}

		self.inHirakanaMap = function(c) {
			for (var i = 0; i < self.hirakanaMap.length; i++) {
				if (self.hirakanaMap[i][1] == c) {
					return true;
				}
			}
			return false;
		}

		self.convertToHiraKana = function(kanaword) {
			var stmp =  '';
			var v = kanaword;
			if(v==stmp) return "";
			var str = '';
			var dest = '';
			var i = 0;
			var c1;
			var c2;
			for (i = 0; i < v.length; i++) {

				//isDoubleChar = false;
				c1 = v.charAt(i);
				c2 = '';
				if (i < v.length -1) {
					c2 = c1 + v.charAt(i+1);
				}


				if (self.inHirakanaMap(c2)) {
					dest = self.convert(c2);
					i++;
				}else {
					dest = self.convert(c1);
				}


				str = str + dest;
			}
			return str;

		}

		self.convertObjectToList = function(listName, obj){
			var data = [];
			var fieldName = Object.getOwnPropertyNames(obj[0])
			for(var i = 0; i< obj.length; i++) {
				for (var j = 0; j < fieldName.length; j++) {
					data[listName+"["+i+"]." + fieldName[j]] = obj[i][fieldName[j]];
				}
			}
			return data;
		};

		self.onlyfullkatakanaReturn = function(words){
			var kana="";
			for(var i=0;i < words.length;i++) {
				var charAtt = words.charAt(i);
				if(charAtt == '－' || charAtt == '―'  || charAtt == "-" || charAtt == "ー" || charAtt == "‐"){
					kana = kana + charAtt;
				} else if(words.charCodeAt(i) >= 0x30a0 && words.charCodeAt(i) <= 0x30ff){
					kana = kana + charAtt;
				}else if(words.charCodeAt(i) == 0x309b  || words.charCodeAt(i) == 0x309c || words.charCodeAt(i) == 0x300c || words.charCodeAt(i) == 0x300d || words.charCodeAt(i) == 0xff0e || words.charCodeAt(i) == 0xff0c || words.charCodeAt(i) == 0xff0f){
					kana = kana + charAtt;
				}
			}
			return kana;
		}

		self.convertHyphenReturn = function (value){
			var result = value.replace(/―/g, "ー").replace(/－/g, "ー");
			return result;
		}

		self.convertToEmhyphen = function(value){
			var result = value;
			if(value != null){
				if(value.includes("－")){
					result = result.replace(/－/g, "‐");
				}
				if(value.includes("-")){
					result = result.replace(/-/g, "‐");
				}
				if(value.includes("―")){
					result = result.replace(/―/g, "‐");
				}
				if(value.includes("ー")){
					result = result.replace(/ー/g, "‐");
				}
			}
			return result;
		}

		self.checkMaxLengthKana = function(kana){
			var length = $(kana).attr("maxlength");
			var result =  length > 0 && $(kana).val().length > Number(length);
			if(result){
				$(kana).val($(kana).val().substring(0, length));
			}
			return result;
		}

		self.replaceByPattern = function(value, pattern){
			if(ValidationUtils.isBlank(value)) return "";
			return value.replace(pattern, "");
		}

		self.getCharacterBirthDate = function(value){
			return self.replaceByPattern(value, /[^0-9//]/g);
		}

		self.getAsciiCharacterOnly = function(value){
			var result = self.getAsciiOnly(value).replace(/[0-9]/g, "");
			return result;
		}

		self.getAsciiOnly = function(value){
			if(ValidationUtils.isBlank(value)) return "";

			var result = "";
			for(var i = 0;i < value.length; i++){
				if(value.charCodeAt(i) < 127){
					result = result + value.charAt(i);
				}
			}
			return result;
		}

		self.getByMaxLength = function(maxLength, value){
			if(maxLength != null && value != null && value.length > maxLength){
				return value.substring(0, maxLength);
			}
			return value;
		}

		self.getLetterNumberAsciiOnly = function(value){
			if(ValidationUtils.isBlank(value)) return "";
			value = value.replace(/[^0-9a-zA-Z]/g, '');
			return value;
		}

		self.getMessageMaxAmountError = function (code) {
			switch (code) {
				case 1:
					return "msg_trs_naf_0060";
				case 2:
					return "msg_trs_naf_0061";
				case 5:
					return "msg_trs_naf_0062";
				case 12:
					return "msg_trs_naf_0063";
				case 25:
					return "msg_trs_naf_0064";
				case 50:
					return "msg_trs_naf_0065";
				case 125:
					return "msg_trs_naf_0066";
				case 250:
					return "msg_trs_naf_0067";
				case 500:
					return "msg_trs_naf_0068";
				default:
					return null;
			}
		}

		self.getPreviousValidDate = function(valueDate, disabledDateOfWeek, disabledDateOfYear, isMinDate){
			var delta = isMinDate ? -1 : 1;
			while(disabledDateOfWeek.indexOf(valueDate.day()) != -1 || disabledDateOfYear.indexOf(valueDate.format('YYYY/MM/DD')) != -1){
				valueDate = valueDate.subtract(delta, 'days');
			}
			return valueDate;
		}

		self.getBool = function (val) {
			return !!JSON.parse(String(val).toLowerCase());
		}

		self.getCurrentPageOnPageJump = function (page, previous, next, maxVisibleButtons) {
			if (previous === true) {
				if (page % maxVisibleButtons === 0) {
					return page;
				} else {
					return parseInt(page / maxVisibleButtons) * maxVisibleButtons + maxVisibleButtons;
				}
			} else {
				if (next === true) {
					if (page % maxVisibleButtons === 0) {
						return page - maxVisibleButtons + 1;
					} else {
						return parseInt(page / maxVisibleButtons) * maxVisibleButtons + 1;
					}
				}
			}
		}

		// Axios Network Error isn't caught by catch block, the only thing it has is message in response (2022/04/18)
		self.isAxiosNetworkError = function(message){
			return message === 'Network Error';
		}

		self.showServerErrorModal = function () {
			ModalPlugin.EventBus.$emit(IConstants.EVENT_NAME.OPEN_SERVER_ERROR_MODAL, {messageText: i18n.t("MSG_NAB005")});
			ModalPlugin.EventBus.$on(IConstants.EVENT_NAME.CLOSE_SERVER_ERROR_MODAL, () => {
				window.location.reload();
			})
		}

		self.validateServerErrorHttpStatus = function (statusCode) {
			if( statusCode === IConstants.STATUS_CODES.INTERNAL_SERVER_ERROR
				|| statusCode === IConstants.STATUS_CODES.NOT_IMPLEMENTED
				|| statusCode === IConstants.STATUS_CODES.BAD_GATEWAY
				|| statusCode === IConstants.STATUS_CODES.SERVICE_UNAVAILABLE
				|| statusCode === IConstants.STATUS_CODES.GATEWAY_TIMEOUT) {
				self.showServerErrorModal();
				return true;
			}
			return false;
		}

		self.newsFetched = false;
		self.checkMaintainModeEOW = function (data) {
			//Change maintenance via Proxy, return data.status = 0
			if( data?.data?.status == 0) {
				window.location.href = process.env.VUE_APP_MAINTAIN_ENDPOINT;
				return true;
			}

			EventBus.$on('newsFetched', newsFetched => {
				self.newsFetched = newsFetched
			});

			if (data?.needRegisterPasskey && store.state.news.needRegisterPasskey && self.newsFetched) {
				if (process.env.NODE_ENV === 'production') {
					window.location.href = `${window.location.origin}/mypage/account/register-passkey`;
					return true;
				} else {
					window.location.href = `${window.location.origin}/account/register-passkey`;
					return true;
				}
			}

			return false;
		}

		self.parseStringJSON = function (str) {
			try {
				return JSON.parse(str);
			} catch (e) {
				return {};
			}
		}

		self.detectUnsupportedBrowser = function () {
			const browser = detect();
			switch (browser && browser.name) {
				case 'ie':
					return true;
				case 'ios':
					if (browser.os === "iOS") {
						return compare(browser.version, '10.3', '<');
					}
					return false;
				default:
					return false;
			}
		}

		self.showUnsupportedBrowserModal = function () {
			ModalPlugin.EventBus.$emit(IConstants.EVENT_NAME.OPEN_UNSUPPORTED_BROWSER_MODAL, {
				title: i18n.t("browser.not_support.title"),
				content: i18n.t("browser.not_support.content")
			});
		}

		self.openMobileApp = function(urlUniversalLink, urlAppStore, googleAuthenticate, urlWebAppStoreLink, urlDeepLink, urlAndroidLink, isIOS, isAndroid, IOSVersion) {
			if (isIOS) {
				if (urlUniversalLink == null) {
					let _target = googleAuthenticate === "true" ? "_self" : "_blank";
					window.open(urlWebAppStoreLink, _target);
					return;
				}
				const isIOS8 = !(IOSVersion >= 9);
				if (isIOS8) {
					const ts = Date.now();
					const timeout = setTimeout(function () {
						if (Date.now() - ts < 1100) {
							window.location = urlAppStore;
						}
					}, 1000);
					let iframe = document.createElement("iframe");
					iframe.onload = function () {
						clearTimeout(timeout);
						iframe.parentNode.removeChild(iframe);
						window.location = urlDeepLink;
					};

					iframe.src = urlDeepLink;
					iframe.setAttribute("style", "display:none;");
					document.body.appendChild(iframe);
				} else {
					// for safari can not handler iframe and back history is not reload
					window.location = urlUniversalLink;
				}
			} else if (isAndroid) {
				if (urlAndroidLink == null) {
					window.open(urlWebAppStoreLink, "_blank");
					return;
				}
				window.location = urlAndroidLink;
			} else {
				window.open(urlWebAppStoreLink, "_blank");
			}
		}

		self.isServiceOpenCompleted = function (serviceStatus) {
			const openCompletedStatuses = [8, 9, 10];
			return openCompletedStatuses.includes(serviceStatus);
		};

		self.isServiceOpenCompletedV2 = function (serviceStatus) {
			const openCompletedStatuses = ['8', '9', '10'];
			return openCompletedStatuses.includes(String(serviceStatus));
		};

		self.base64UrlToUint8Array = function (base64Url) {
			if (!base64Url) return new Uint8Array(0)

			let base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/")
			const pad = base64.length % 4
			if (pad) {
				base64 += "=".repeat(4 - pad)
			}

			const binary = atob(base64)
			const bytes = new Uint8Array(binary.length)
			for (let i = 0; i < binary.length; i++) {
				bytes[i] = binary.charCodeAt(i)
			}
			return bytes
		}
		self.uint8ArrayToBase64Url = function (buffer) {
			let binary = ""
			const bytes = new Uint8Array(buffer)
			for (let i = 0; i < bytes.byteLength; i++) {
				binary += String.fromCharCode(bytes[i])
			}
			return btoa(binary)
				.replace(/\+/g, '-')
				.replace(/\//g, '_')
				.replace(/=+$/, '');
		}
		self.genMakeCredentialRequestV1 = function (res) {
			let makeCredentialRequestV1 = res.w3cMakeCredentialRequest.makeCredentialRequestV1;
			if (!makeCredentialRequestV1) return null;

			makeCredentialRequestV1.challenge = self.base64UrlToUint8Array(makeCredentialRequestV1.challenge);

			if (makeCredentialRequestV1.user) {
				if (makeCredentialRequestV1.user.id) makeCredentialRequestV1.user.id = self.base64UrlToUint8Array(makeCredentialRequestV1.user.id);

				// custom name shown in the passkey registration popup
				if (res.customDisplayName) {
					makeCredentialRequestV1.user.name = res.customDisplayName;
					makeCredentialRequestV1.user.displayName = res.customDisplayName
				}
			}

			if (Array.isArray(makeCredentialRequestV1.excludeCredentials) && makeCredentialRequestV1.excludeCredentials.length > 0) {
				makeCredentialRequestV1.excludeCredentials = makeCredentialRequestV1.excludeCredentials.map((cred) => ({
					...cred,
					type: cred.type || 'public-key',
					id: self.base64UrlToUint8Array(cred.id),
				}))
			} else delete makeCredentialRequestV1.excludeCredentials;

			// Safari compatibility
			if (!makeCredentialRequestV1.authenticatorSelection) delete makeCredentialRequestV1.authenticatorSelection;

			// uncomment for working on localhost
			// makeCredentialRequestV1.rp.id = 'localhost'
			return {
				publicKey: makeCredentialRequestV1
			}
		};
		self.genGetAssertionRequestV1 = function (res) {
			let getAssertionRequestV1 = res.w3cGetAssertionRequest.getAssertionRequestV1;
			if (!getAssertionRequestV1) return null;

			getAssertionRequestV1.challenge = self.base64UrlToUint8Array(getAssertionRequestV1.challenge);

			if (Array.isArray(getAssertionRequestV1.allowCredentials) && getAssertionRequestV1.allowCredentials.length > 0) {
				getAssertionRequestV1.allowCredentials =
					getAssertionRequestV1.allowCredentials.map((cred) => ({
						...cred,
						type: cred.type || 'public-key',
						id: self.base64UrlToUint8Array(cred.id),
					}))
			} else delete getAssertionRequestV1.allowCredentials;

			// uncomment for working on localhost
			// getAssertionRequestV1.rpId = 'localhost'
			return {
				publicKey: getAssertionRequestV1
			}
		};
		self.genW3cMakeCredentialResponse = function(credential) {
			return {
				makeCredentialResponseV1: {
					id: credential.id,
					rawId: self.uint8ArrayToBase64Url(credential.rawId),
					type: credential.type || 'public-key',
					response: {
						attestationObject: self.uint8ArrayToBase64Url(credential.response.attestationObject),
						clientDataJSON: self.uint8ArrayToBase64Url(credential.response.clientDataJSON)
					}
				}
			}
		};
		self.genW3cGetAssertionResponse = function (assertion) {
			return {
				getAssertionResponseV1: {
					assertion: {
						id: assertion.id,
						rawId: self.uint8ArrayToBase64Url(assertion.rawId),
						type: assertion.type || 'public-key',
						response: {
							clientDataJSON: self.uint8ArrayToBase64Url(assertion.response.clientDataJSON),
							authenticatorData: self.uint8ArrayToBase64Url(assertion.response.authenticatorData),
							signature: self.uint8ArrayToBase64Url(assertion.response.signature),
							userHandle: assertion.response?.userHandle ? self.uint8ArrayToBase64Url(assertion.response.userHandle) : null,
						},
					},
				},
			}
		};
		self.isUserCancelOrTimeoutPasskeyAction = function (exception) {
			return exception?.name === 'NotAllowedError' || exception?.name === 'AbortError';
		};

		self.isDeviceNotSupportPasskey = function (exception) {
			return exception?.name === 'NotSupportedError';
		};

		self.waitModalFullyHidden = function (modalSelector) {
			return new Promise(resolve => {
				if (!modalSelector?.length) return resolve();
				if (!modalSelector.hasClass('show')) return resolve();

				modalSelector.one('hidden.bs.modal', () => {
					resolve();
				});
				modalSelector.modal('hide');
			});
		};
		self.isFidoAuthenticateUnsupported = function () {
			return typeof window === "undefined"
				|| typeof window.PublicKeyCredential !== "function"
				|| typeof navigator.credentials === "undefined"
		};
		self.detectSelectedAuthenticator = function (cred) {
			const attachment = cred?.authenticatorAttachment;
			let transports = [];

			try {
				transports = cred?.response?.getTransports?.() || [];
			} catch {
				// intentionally ignored (browser does not support getTransports)
			}
			const ua = navigator.userAgent.toLowerCase();
			if (transports.includes("hybrid")) {
				if (/windows/.test(ua) && /chrome/.test(ua) && !/edg/.test(ua)) return "Windows – Passkey (Google Password Manager)";
				if (/iphone|ipad/.test(ua)) return "iPhone – Passkey (iCloud Keychain)";
				if (/android/.test(ua)) return "Android – Passkey (Google Password Manager)";
				return "Cross-device Passkey";
			}

			if (attachment === "platform" || transports.includes("internal")) {
				if (/mac os/.test(ua)) return "macOS – Touch ID / iCloud Keychain";
				if (/iphone|ipad/.test(ua)) return "iOS – Face ID / Touch ID / iCloud Keychain";
				if (/android/.test(ua)) return "Android – Biometrics / Screen Lock";
				if (/windows/.test(ua)) return "Windows – Windows Hello";
				return "Platform – Built-in Passkey";
			}

			if (attachment === "cross-platform") {
				if (transports.includes("usb")) return "Security Key – USB";
				if (transports.includes("nfc")) return "Security Key – NFC";
				if (transports.includes("ble")) return "Security Key – Bluetooth";
				return "Security Key – External";
			}

			if (/safari/.test(ua) && attachment == null) return "Safari – Passkey (Limited Info)";
			return "Unknown – Authenticator";
		};
		self.getMaskingPerSessionScreens = function () {
			return [IConstants.SCREEN_NAME.CUSTOMER_INFO, IConstants.SCREEN_NAME.CUSTOMER_REPORT]
		};
		self.getMaskingPerRequestScreens = function () {
			return [IConstants.SCREEN_NAME.WITHDRAWAL]
		};
		self.currentScreenMaskingVerified = function (authInfo, screenName) {
			if (String(screenName) === IConstants.SCREEN_NAME.WITHDRAWAL) return authInfo.maskingVerifiedPerRequest;
			if (String(screenName) === IConstants.SCREEN_NAME.CUSTOMER_INFO || String(screenName) === IConstants.SCREEN_NAME.CUSTOMER_REPORT)
				return authInfo.maskingVerifiedPerSession;
			return false;
		};
		self.hasValue = function (value) {
			return value !== undefined
				&& value !== null
				&& !(typeof value === 'string' && value.trim() === '');
		};

export default self;
